export enum MultipleYesNoFeedbackAnswerOption {
  Yes = 'yes',
  No = 'no',
}
